import React from "react";
import { useTranslation, Trans } from "react-i18next";
import LegalPageShell from "./LegalPageShell";

const CookiesPolicy = () => {
  const { t } = useTranslation("auth");
  const effectiveDate = "01 June 2025"; // keep editable

  return (
    <LegalPageShell>
        <h1 className="text-2xl md:text-3xl font-bold mb-6 text-center">
          {t("cookies.title")}
        </h1>

        <p className="italic text-center mb-4">
          <Trans i18nKey="cookies.effective" ns="auth" components={{ strong: <strong /> }} values={{ date: effectiveDate }} />
        </p>

        {/* ------------------------------------------------------------ */}
        <h2 className="text-xl font-semibold mt-8 mb-3">{t("cookies.s1.title")}</h2>
        <p className="mb-4">{t("cookies.s1.p1")}</p>

        {/* ------------------------------------------------------------ */}
        <h2 className="text-xl font-semibold mt-8 mb-3">{t("cookies.s2.title")}</h2>
        <p className="mb-4">{t("cookies.s2.p1")}</p>
        <p className="mb-4">{t("cookies.s2.p2")}</p>
        <p className="mb-4">{t("cookies.s2.p3")}</p>

        {/* ------------------------------------------------------------ */}
        <h2 className="text-xl font-semibold mt-8 mb-3">{t("cookies.s3.title")}</h2>

        <h3 className="font-semibold mb-2">{t("cookies.s3_1.title")}</h3>
        <ul className="list-disc pl-5 space-y-1 mb-4">
          <li>{t("cookies.s3_1.li1")}</li>
          <li>{t("cookies.s3_1.li2")}</li>
          <li>{t("cookies.s3_1.li3")}</li>
        </ul>

        <h3 className="font-semibold mb-2">{t("cookies.s3_2.title")}</h3>
        <p className="mb-4">{t("cookies.s3_2.p1")}</p>

        <h3 className="font-semibold mb-2">{t("cookies.s3_3.title")}</h3>
        <p className="mb-2">{t("cookies.s3_3.p1")}</p>

        <h3 className="font-semibold mb-2">{t("cookies.s3_4.title")}</h3>
        <p className="mb-4">{t("cookies.s3_4.p1")}</p>

        {/* ------------------------------------------------------------ */}
        <h2 className="text-xl font-semibold mt-8 mb-3">{t("cookies.s4.title")}</h2>
        <p className="mb-4">{t("cookies.s4.p1")}</p>

        {/* ------------------------------------------------------------ */}
        <h2 className="text-xl font-semibold mt-8 mb-3">{t("cookies.s5.title")}</h2>
        <p className="mb-4">{t("cookies.s5.p1")}</p>

        {/* ------------------------------------------------------------ */}
        <h2 className="text-xl font-semibold mt-8 mb-3">{t("cookies.s6.title")}</h2>
        <p className="mb-4">{t("cookies.s6.p1")}</p>

        {/* ------------------------------------------------------------ */}
        <h2 className="text-xl font-semibold mt-8 mb-3">{t("cookies.s7.title")}</h2>
        <p className="mb-4">
          <Trans
            i18nKey="cookies.s7.p1"
            ns="auth"
            components={{
              a: (
                <a
                  href="mailto:support@vaultgrid.net"
                  className="underline"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="VaultGrid support email"
                />
              ),
            }}
          />
        </p>
    </LegalPageShell>
  );
};

export default CookiesPolicy;
